import React from 'react';

interface Branch {
  id: string | number;
  name: string;
}

interface StepProps {
  formData: {
    branchId: string | number;
    price: string | number;
    stock: string | number;
    isAvailable: boolean;
  };
  onInputChange: (field: string, value: any) => void;
  branches: Branch[];
}

// Step 4: Branch Assignment
const Step4BranchAssignment: React.FC<StepProps> = ({ 
  formData, 
  onInputChange,
  branches 
}) => {
  return (
    <div className="space-y-6">
      <h3 className="text-xl font-semibold text-gray-800">Assign to Branch</h3>
      
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          Which branch will sell this product? *
        </label>
        <select
          required
          value={formData.branchId}
          onChange={(e) => onInputChange('branchId', e.target.value)}
          className="block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select a branch...</option>
          {branches.map((branch) => (
            <option key={branch.id} value={branch.id}>
              {branch.name}
            </option>
          ))}
        </select>
        <p className="mt-1 text-sm text-gray-500">Choose the branch where this product will be available</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Branch price *
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <span className="text-gray-500">$</span>
            </div>
            <input
              type="number"
              required
              min="0"
              step="0.01"
              value={formData.price}
              onChange={(e) => onInputChange('price', e.target.value)}
              className="block w-full pl-7 pr-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="0.00"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Initial stock quantity *
          </label>
          <input
            type="number"
            required
            min="0"
            value={formData.stock}
            onChange={(e) => onInputChange('stock', e.target.value)}
            className="block w-full px-4 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            placeholder="0"
          />
        </div>
      </div>

      <div className="flex items-start p-4 bg-gray-50 rounded-lg">
        <input
          id="availability"
          type="checkbox"
          checked={formData.isAvailable}
          onChange={(e) => onInputChange('isAvailable', e.target.checked)}
          className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded mt-1"
        />
        <div className="ml-3">
          <label htmlFor="availability" className="block text-sm font-medium text-gray-700">
            Make product available at this branch
          </label>
          <p className="text-sm text-gray-500">
            If unchecked, the product will be hidden from customers
          </p>
        </div>
      </div>
    </div>
  );
};

export default Step4BranchAssignment;
